<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">사이트상세</h4>
        </template>
        <div class="row">
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">이미지</label>
              <div class="col-sm-8">
                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileUrl" @onChangeFileIds="onFileIdChange" />
              </div>
            </div>
          </div>
        </div>
        <div class="row has-image">
          <div class="col-sm-4">
            <label class="col-form-label">제목 (ko)</label>
            <base-input placeholder="한국어 제목" v-model="titleKo">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <div class="col-sm-4">
            <label class="col-form-label">제목 (en)</label>
            <base-input placeholder="English title" v-model="titleEn">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <div class="col-sm-4">
            <label class="col-form-label">제목 (ja)</label>
            <base-input placeholder="日本語タイトル" v-model="titleJa">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">설명 (ko)</label>
            <base-input placeholder="한국어 부제목" v-model="title2Ko">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <div class="col-sm-4">
            <label class="col-form-label">설명 (en)</label>
            <base-input placeholder="English subtitle" v-model="title2En">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <div class="col-sm-4">
            <label class="col-form-label">설명 (ja)</label>
            <base-input placeholder="日本語サブタイトル" v-model="title2Ja">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row has-image">
          <label class="col-sm-2 col-form-label">링크</label>
          <div class="col-sm-10">
            <base-input placeholder="링크" v-model="link">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>

          <label class="col-sm-2 col-form-label">시간설정</label>
          <div class="col-sm-3">
            <h4 class="card-title text-left">노출시작시간</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="시작시간">
                  <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <h4 class="card-title text-left">노출종료시간</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="종료시간">
                  <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
      <!--      <base-button v-if="siteId && state === 1" @click="setSiteState(0)" type="default">숨김</base-button>-->
      <!--      <base-button v-if="siteId" @click="setSiteState(-1)" type="danger">삭제</base-button>-->
      <!--      <base-button v-if="siteId && state === 0" @click="setSiteState(1)" type="default">표시</base-button>-->
    </form>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import BlipFileUploadZone from "@/components/BlipFileUploadZone";

export default {
  components: {
    Card,
    BaseInput,
    BlipFileUploadZone,
  },
  async created() {
    if (this.$route.query.siteId) {
      this.siteId = Number(this.$route.query.siteId);
      await this.getData();
    }
  },
  data() {
    return {
      siteId: null,
      imageFileId: null,
      imageFileUrl: null,
      link: null,
      titleKo: "",
      titleEn: "",
      titleJa: "",
      title2Ko: "",
      title2En: "",
      title2Ja: "",
      startTime: null,
      endTime: null,
      state: 1,
    };
  },
  methods: {
    onFileIdChange(newFileIds) {
      this.imageFileId = newFileIds[0];
    },

    async getData() {
      return this.$axios.get(`/homepage/sites/${this.siteId}`).then((res) => {
        const data = res.data.data;
        if (data) {
          this.imageFileId = data.imageFileId;
          this.link = data.link;
          this.startTime = data.startTime;
          this.endTime = data.endTime;
          this.state = data.state;
          const title = data.title || {};
          const title2 = data.title2 || {};
          this.titleKo = title.ko || "";
          this.titleEn = title.en || "";
          this.titleJa = title.ja || "";
          this.title2Ko = title2.ko || "";
          this.title2En = title2.en || "";
          this.title2Ja = title2.ja || "";
          if (this.imageFileId) {
            this.imageFileUrl = window.Endpoints.imageServerUrl + this.imageFileId;
          }
        }
      });
    },
    async setSiteState(state) {
      return this.$axios
        .put(`/homepage/sites/${this.siteId}/state`, {
          state,
        })
        .then((res) => {
          Toast.success("상태가 변경되었습니다");
          this.state = state;
        });
    },

    async onSubmit() {
      if (!this.imageFileId && !this.imageFileUrl) {
        Toast.error("이미지는 필수입니다");
        return;
      }
      const title = {
        ko: this.titleKo,
        en: this.titleEn,
        ja: this.titleJa,
      };
      const title2 = {
        ko: this.title2Ko,
        en: this.title2En,
        ja: this.title2Ja,
      };

      const param = {
        imageFileId: this.imageFileId,
        link: this.link,
        title,
        title2,
        startTime: this.startTime,
        endTime: this.endTime,
      };

      if (this.siteId) {
        return this.$axios
          .put(`/homepage/sites/${this.siteId}`, {
            ...param,
          })
          .then((res) => {
            Toast.success("사이트가 수정되었습니다");
          });
      } else {
        return this.$axios
          .post("/homepage/sites", {
            ...param,
          })
          .then((res) => {
            Toast.success("사이트가 등록되었습니다");
          });
      }
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.has-image {
  padding-top: 100px;
}
.artist-selection {
  margin-bottom: 20px;
}
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}
</style>
